<template>
    <div>
        <el-input ref="editInput" maxlength="11" v-model.trim="fin_charges" @input.native="ex" size="mini" clearable @blur="reBack"></el-input>
    </div>
</template>

<script>
export default {
    name: 'FinEditInput',
    props: {
        price: {
            type: String
        },
        cid: {
            type: Number
        }
    },
    data() {
        return {
            fin_charges: '',
            company_id: '',
            timer_edit_body: null,
        }
    },
    watch: {
        price(n) {
            this.fin_charges = ''
            if (n) {
                this.fin_charges = n
            }
        },
        cid(n) {
            this.company_id = ''
            this.flag = false
            if (n) {
                this.company_id = n
                this.flag = true
            }
        },
    },
    methods: {
        ex () {
            this.doEditPrice()
        },
        doEditPrice() {
            if (this.timer_edit_body) {
                clearTimeout(this.timer_edit_body)
            }
            this.timer_edit_body = setTimeout(() => {
                this.$nextTick(() => {
                    this.execEditPrice()
                })
            }, 400)
        },
        execEditPrice() {
            if (!this.company_id) return false
            if (this.fin_charges) {
                var reg = /^-?\d{1,8}(?:\.\d{1,2})?$/ // 小数点左边最高4位，小数点右边最多4位
                if (!reg.test(this.fin_charges)) {
                    this.$message.error('输入只能是数字,小数点左边最多8位,右边2位!')
                    return false
                }
            }
            this.$axios.put('api/finance/edit_fin_charges', {
                cid: this.company_id,
                fin_charges: this.fin_charges
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.$message.success(data.msg)
                    this.$emit('updatePrice', this.fin_charges,this.company_id);
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        reBack() {
            this.$emit('revert')
        }
    },
    mounted() {
        this.$refs.editInput.focus()
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/finance_register/EditInput.vue